<script lang="ts">
  import { cn } from '$lib/utils';
  import { cva } from 'class-variance-authority';

  export let element: undefined | HTMLInputElement = undefined;

  let className: undefined | string = undefined;
  export { className as class };
  export let checked = false;
  export let indeterminate = false;

  const base = cva(
    `
    checkbox-tick

    h-4
    w-4
    appearance-none
    outline-none
    
    bg-transparent
    border-2
    border-primary
    rounded-micro

    hover:bg-primary/4

    focus:ring
    focus:outline-none
    peer-focus:ring
    peer-focus:ring-outline
    peer-focus:outline-none
    checked:border-accent
    checked:text-accent

    disabled:opacity-60
    disabled:pointer-events-none

    transition-all
  `
  );
</script>

<input
  bind:this={element}
  class={cn(base(), className)}
  type="checkbox"
  bind:checked
  bind:indeterminate
  on:change
  on:mouseenter
  on:mouseleave
  on:click
  on:focus
  on:blur
  {...$$restProps}
/>
